// Export the FAIcon component and mapping utilities
export { FAIcon } from '@packages/ui-components';
export { fontAwesomeToLucideMap, getLucideIcon } from './lucide-mapping';

// Export commonly used Lucide icons for direct import
export {
  Plus,
  Minus,
  Check,
  X,
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  ChevronRight,
  Menu,
  Settings,
  Search,
  Edit,
  Trash,
  Eye,
  EyeOff,
  Home,
  User,
  Bell,
  Calendar,
  File,
  Folder,
  Image,
  Video,
  Play,
  Pause,
  Volume2,
  Star,
  Share2,
  Download,
  Upload,
  Copy,
  Save,
  Loader2,
  type LucideIcon
} from './lucide-mapping';
